export const API_ERROR_MESSAGES = {
  400: "Invalid request data",
  403: "You don't have permission to perform this action",
  404: "The requested resource was not found",
  500: "Something went wrong on our end",
  502: "The server is temporarily unavailable",
  504: "The server took too long to respond. Please try again later.",
};

export const possibleErrorMessageTypes = [
  "message",
  "msg",
  "error",
  "err",
  "errorMessage",
  "errMsg",
  "errorMsg",
];
